import { render, staticRenderFns } from "./SearchAndroid.vue?vue&type=template&id=47c19e72&"
import script from "./SearchAndroid.vue?vue&type=script&lang=js&"
export * from "./SearchAndroid.vue?vue&type=script&lang=js&"
import style0 from "./SearchAndroid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports